import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/content";

const Faq = () => (
  <section id="faq" className="py-28 md:py-36" data-testid="faq-section">
    <div className="max-w-5xl mx-auto px-6">
      <Reveal className="mb-16">
        <p className="font-mono-p text-xs tracking-[0.35em] uppercase text-[#0055FF] mb-4">
          Reader Questions
        </p>
        <h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight">
          Asked constantly. Answered honestly.
        </h2>
      </Reveal>

      <Reveal>
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-white/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-serif-d text-xl md:text-2xl text-left py-8 hover:text-[#0055FF] hover:no-underline transition-colors duration-300"
              >
                <span className="flex items-baseline gap-6">
                  <span className="font-oswald text-sm text-stroke shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="font-mono-p text-sm leading-relaxed text-[#A1A1AA] pb-8 md:pl-14 max-w-3xl"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
